export enum EAccountIsFired {
	Fired = 'Fired',
	NotFired = 'NotFired',
}

export const ACCOUNT_IS_FIRED_LABEL_MAP: Record<EAccountIsFired, string> = {
	[EAccountIsFired.Fired]: `account_is_fired.${EAccountIsFired.Fired}`,
	[EAccountIsFired.NotFired]: `account_is_fired.${EAccountIsFired.NotFired}`
}